import create from "zustand";
import { Modal } from "bootstrap";

import makeid from "../../lib/makeid";

const useStore = create((set) => ({
  ids: [],
  open: (id) => {
    document.querySelectorAll(".modal").forEach((element) => {
      try {
        Modal.getInstance(element).hide();
      } catch {}
    });

    // Bug real (auditoría 2026-08-16): antes se agregaba el id nuevo al
    // array ("uniq([...state.ids, id])") en vez de reemplazarlo — con dos
    // llamadas abiertas a la vez (ej: "Nueva videollamada" minimizada +
    // "Videoconsulta" de un turno agendado), App.js monta dos <Room> a la
    // vez, y cada uno renderiza el mismo <div id="SimpleVideoApp"> literal
    // (Room.js) — HTML inválido y mount target ambiguo para el script de
    // meet, con riesgo de que el video/audio de una llamada termine
    // renderizando en la ventana flotante de la otra. Además .Room está
    // anclada fixed;bottom:0;right:0 (styles.scss) sin ningún offset por
    // instancia — dos <Room> montados quedan superpuestos exactamente en el
    // mismo lugar, nunca coexistiendo de forma usable. La UI (una sola
    // ventana dockeada) y el bootstrap (un único window.SimpleVideoApp
    // global) confirman que el producto nunca soportó dos llamadas reales
    // simultáneas — se reemplaza el array en vez de agregarle, cerrando
    // cualquier sala previa (dispara el cleanup de desmontaje de Room, que
    // ya llama a SimpleVideoApp.close() de forma segura) antes de abrir la
    // nueva.
    return set(() => ({
      ids: [id || makeid(8)],
    }));
  },
  close: (value) =>
    set((state) => ({
      ids: state.ids.filter((id) => id !== value),
    })),
}));

export default useStore;
